module.exports = "https://99designs-start-assets.imgix.net/js/672c67b9c157a34748ee2674e311304a.png";